import { revealPage } from '../core/page-reveal/reveal-page'

export const initPageReveal = (ctx) => {
	const runPageReveal = (mode) => requestAnimationFrame(() => revealPage(mode))

	// const onDomReady = () => runPageReveal('direct')
	// if (document.readyState === 'loading') {
	// 	document.addEventListener('DOMContentLoaded', onDomReady, { once: true })
	// } else {
	// 	onDomReady()
	// }

	const swup = ctx.swup

	if (swup) {
		swup.hooks.on(
			'content:replace',
			(visit) => {
				const isHistory = visit?.history?.popstate === true
				runPageReveal(isHistory ? 'history' : 'swup')
			},
			{ after: true }
		)
	} else {
		window.addEventListener('popstate', () => runPageReveal('history'))
	}

	return { runPageReveal }
}
